export const ImportComment = {
  "title": "Import Comments from Foxit PDF Editor",
  "Cancel": "Cancel",
  "Continue": "Continue",
  "PDFFile": "Take comments from this PDF file:",
  "WordFile": "Place comments in this Word file",
  "ChooseFiles": "Choose Files",
  "ChooseType": "Select Comment Types to Import",
  "AllComments": "All Comments",
  "AllCommentswithCheckmarks": "All Comments with Checkmarks",
  "TextEditsOnly": "Text Edits Only: Insertions, Deletions and Replaces",
  "statisticsTitle": "Successful Import",
  "Done": "Done",
  "importDes": "The comments have been successfully imported from",
  "summary": "Import Summary",
  "TotalComments": "Total number of comments imported:",
  "textEdits": "Text Edits(Insertions, Deletions and Replaces):",
  "otherComments": "Other comments:",
  "placement": "Comments with unconfirmed placement:",
  "isPasswordPDF": "The PDF you have selected is a protected PDF. Please unprotect it before the operation.",
  "errorFilePath": "Please enter a valid file path or click 'Browse' to find it."
}